<div>
  <div style="padding-top: 8rem">
    <!--<a routerLink="/register" class="auth-link">New to ng2-admin? Sign up!</a>-->

    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit(form.value)"
      class="form-horizontal"
    >
      <div
        *ngIf="SendMail!=true && loginService.searchUser!=true || loginService.loginpage==true"
      >
        <div class="auth-block">
          <h1>Sign in</h1>
          <div
            class="form-group row"
            [ngClass]="{'has-error': (email.touched), 'has-success': (email.touched)}"
          >
            <label for="inputEmail36" class="col-sm-2 control-label"
              >Email</label
            >

            <div class="col-sm-10">
              <input
                [formControl]="email"
                type="text"
                class="form-control"
                id="inputEmail36"
                placeholder="Email"
              />
            </div>
          </div>
          <div
            class="form-group row"
            [ngClass]="{'has-error': (!password.valid && password.touched), 'has-success': (password.valid && password.touched)}"
          >
            <label for="inputPassword36" class="col-sm-2 control-label"
              >Password</label
            >

            <div class="col-sm-10">
              <input
                [formControl]="password"
                type="password"
                class="form-control"
                id="inputPassword36"
                placeholder="Password"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="offset-sm-2 col-sm-10">
              <button
                [disabled]="!form.valid"
                type="submit"
                class="btn btn-default btn-auth"
              >
                Sign in
              </button>
              <a (click)="ForgetPassword()" class="forgot-pass"
                >Forgot password?</a
              >
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="loginService.searchUser==true && loginService.sendMail!=true && loginService.loginpage!=true"
      >
        <SearchUser></SearchUser>
      </div>
      <div
        *ngIf="loginService.sendMail==true && loginService.securityCode!=true && loginService.loginpage!=true"
      >
        <SendEmail></SendEmail>
      </div>
      <div
        *ngIf="loginService.securityCode==true && loginService.newPassword!=true && loginService.loginpage!=true"
      >
        <enterSecurity></enterSecurity>
      </div>
      <div
        *ngIf="loginService.newPassword==true && loginService.loginpage!=true"
      >
        <newPassword></newPassword>
      </div>
    </form>
    <div class="cookieBox" *ngIf="cookiebox">
      <div class="txtbox">
        <span>
          By using our app you acknowledge that you read and understand our
          Cookie Policy, Privacy Policy and our Terms of Service</span
        >
      </div>
      <div class="btnbox">
        <button class="btn1" (click)="decline()">Decline</button>
        <button class="btn2" (click)="allow()">Allow</button>
      </div>
    </div>
    <!--<div class="auth-sep"><span><span>or Sign in with one click</span></span></div>

    <div class="al-share-auth">
      <ul class="al-share clearfix">
        <li><i class="socicon socicon-facebook" title="Share on Facebook"></i></li>
        <li><i class="socicon socicon-twitter" title="Share on Twitter"></i></li>
        <li><i class="socicon socicon-google" title="Share on Google Plus"></i></li>
      </ul>
    </div>-->
  </div>
</div>
<div
  class="modal fade"
  bsModal
  #childModal="bs-modal"
  [config]="{backdrop: 'static'}"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" aria-label="Close" (click)="hideChildModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Information18</h4>
      </div>
      <div class="modal-body">{{DialogMessage}}</div>
    </div>
  </div>
</div>
<style>
  a:hover {
    color: #f7d559 !important;
    cursor: pointer;
  }
</style>
